/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Ai_Help_TitleInputs */

const en_serve_ai_help_title = /** @type {(inputs: Serve_Ai_Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sure? Let your AI assistant walk you through it`)
};

const id_serve_ai_help_title = /** @type {(inputs: Serve_Ai_Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum yakin? Biarkan asisten AI-mu memandu`)
};

/**
* | output |
* | --- |
* | "Not sure? Let your AI assistant walk you through it" |
*
* @param {Serve_Ai_Help_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_ai_help_title = /** @type {((inputs?: Serve_Ai_Help_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Ai_Help_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_ai_help_title(inputs)
	return en_serve_ai_help_title(inputs)
});